import {connect} from 'react-redux'

import {adPageUrlSelector, adProductSelector, isProductOwnerSelector} from 'data/redux/selectors/productSelector';
import {getLoadProductActionCreator} from 'data/redux/actions/productsActions';
import Ad from 'gui/pages/mainRouter/pages/ad/Ad';
import {linksMap, USER_TYPE_ADMIN} from 'data/utils/constants';
import {getNavigationAllowed} from 'data/redux/selectors/routerSelector';
import {AuthenticatedMapStateToProps} from 'data/redux/containers/commons/Commons';
import {userIsAllowed, userSelector} from 'data/redux/selectors/userSelector';
import {transactionSelector} from 'data/redux/selectors/transactionSelector';
import {beginOrder, getLoadProductOrdersActionCreator} from 'data/redux/actions/ordersActions';
import {isProductOrderOwnerSelector, orderSelector} from 'data/redux/selectors/orderSelector';
import {autoFixSlug} from 'data/redux/actions/guiActions';
import {navigateIfNotThere} from 'data/redux/actions/navigationActions';

const mapStateToProps = (state) => {
  const product = adProductSelector(state);
  const {id, ...restParsedUrl}: any = adPageUrlSelector(state);
  return {
    product: product,
    order: orderSelector(product)(state),
    transaction: transactionSelector(product)(state),
    user: userSelector(state),
    allowNavigation: getNavigationAllowed(state),
    id: parseInt(id || 0),
    isProductOwner: isProductOwnerSelector(state),
    isOrderOwner: isProductOrderOwnerSelector(product)(state),
    isAdmin: userIsAllowed(USER_TYPE_ADMIN)(state),
    ...restParsedUrl,
    ...AuthenticatedMapStateToProps(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAdPage: (id: number) => dispatch(getLoadProductActionCreator(id)),
    loadAllOrdersToProduct: (product_id) => dispatch(getLoadProductOrdersActionCreator(product_id)),
    beginOrder: (product, options) => dispatch(beginOrder(product, options)),
    autoFixSlug: (product) => dispatch(autoFixSlug(product)),
    goToCheckout: (id: number) => dispatch(navigateIfNotThere(linksMap.checkoutIdSlug.replace(":id", id as any))),
  };
};

const AdContainer = connect(mapStateToProps, mapDispatchToProps)(Ad as any);

export default AdContainer;
